//#region src/components/Calendar/utils/variant-classes.ts
/** Full literal class strings — Tailwind must see them unconcatenated. */
var EVENT_VARIANT_CLASSES = {
	caution: "border-caution bg-caution-faded",
	critical: "border-critical bg-critical-faded",
	info: "border-info bg-info-faded",
	main: "border-main bg-main-faded",
	neutral: "border-border bg-surface-subtle",
	positive: "border-positive bg-positive-faded"
};
function eventBlockClasses(event) {
	const dashed = event.appearance === "dashed" ? " border-dashed opacity-70" : "";
	return `${EVENT_VARIANT_CLASSES[event.variant]}${dashed}`;
}
//#endregion
export { EVENT_VARIANT_CLASSES, eventBlockClasses };

//# sourceMappingURL=variant-classes.js.map